/** CSS Custom Highlight API のハイライト登録簿。未対応環境 (古いブラウザ・jsdom) では null。 */
export function highlightRegistry(): HighlightRegistry | null {
	if (typeof CSS === "undefined" || !("highlights" in CSS)) return null;
	return CSS.highlights;
}
